/**
 * PLP advice stays fully visible. This file used to hide the second paragraph
 * behind "View your style advice"; that wrap is intentionally a no-op.
 */
(function () {
  function run() {}

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
